import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import DesktopFrontPage from './components/DesktopFrontPage';
import MobileFrontPage from './components/MobileFrontPage';
import DesktopPrototype from './components/DesktopPrototype';
import { getDeviceRoute } from './utils/deviceDetection';

// Component to handle automatic device detection and routing
const DeviceRouter = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const deviceRoute = getDeviceRoute();
    navigate(deviceRoute, { replace: true });
  }, [navigate]);

  return <div>Detecting device...</div>;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Root route - detects device and redirects */}
        <Route path="/" element={<DeviceRouter />} />
        
        {/* Desktop version */}
        <Route path="/desktop" element={<DesktopFrontPage />} />
        
        {/* Mobile version */}
        <Route path="/mobile" element={<MobileFrontPage />} />
        
        {/* Prototype version */}
        <Route path="/desktopprototype" element={<DesktopPrototype />} />

        {/* Fallback - redirect to root for device detection */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;